import React, { useEffect, useState, useCallback } from "react";
import BaseCard from "../components/BaseCard";
import styles from "./index.module.less";
import { Carousel, message } from "antd";
import { queryBanner } from "@/api/workCards";

function NewsBannerCard(props: any) {
  // console.log("news-props", props);
  // 卡片高度与移动端保持一致  宽高比为 9:5
  let cardH = `${Math.ceil(330 / 1.8)}px`;
  const { cardInfo, openNewPage, isPrivateNet } = props;
  const [bannerList, setBannerList] = useState<any>([]);

  const queryBannerList = useCallback(async () => {
    let res: any = await queryBanner();
    // 错误处理。。。
    if (res?.errorCode) {
      message.error(res.errorMsg);
      return;
    }
    let list = [];
    if (res?.list) {
      list = res?.list?.slice(0, 10);
    }
    setBannerList(list);
  }, []);

  // 点击查看详情
  const viewDetail = (data: any) => {
    let openUrl = isPrivateNet ? data.desktopLinkEgov : data.desktopLink;
    let params = {
      openUrl,
      appKey: cardInfo.applicationKey,
      openApiType: 2,
      code: "code"
    };
    openNewPage(params);
  };

  useEffect(() => {
    // 查询新闻列表
    queryBannerList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BaseCard style={{ height: cardH }}>
      {bannerList.length > 0 ? (
        <Carousel autoplay style={{ height: cardH, width: "100%" }}>
          {bannerList.map((item: any) => {
            return (
              <div
                key={item.id}
                data-url={item.desktopLink}
                className={styles["slide-wrap"]}
                onClick={(e) => {
                  e.stopPropagation();
                  // eslint-disable-next-line no-console
                  console.log("itemslide", item);
                  viewDetail(item);
                }}
              >
                <div
                  style={{
                    backgroundImage: `url(${item?.imgurl})`,
                    backgroundSize: "100% 100%",
                    borderRadius: "4px",
                    height: cardH,
                    position: "relative"
                  }}
                >
                  <div className={styles["news-title"]}>{item?.title}</div>
                  <p className={styles["news-date"]}>{item?.createTime}</p>
                </div>
              </div>
            );
          })}
        </Carousel>
      ) : (
        <div className={styles["no-data"]}>
          <div>暂无数据</div>
        </div>
      )}
    </BaseCard>
  );
}

export default NewsBannerCard;
